module.exports = __webpack_public_path__ + "img/twitter.80c0f9b6.svg";